import { memo, useCallback, useMemo } from "react";

import { BillingTypeTarget, BillingTypeTerm } from "@/lib/gql/__generated__/graphql";

import { ApplyPriceText } from "../../components";

import type { QueryData } from "../../../model";

type Props = {
	// 大人の数
	adultNum: number;
	// 子どもの数
	kidsNum: number;
	// 部屋の数
	roomNum: number;
	// 宿泊日ごとのアイテム
	aliveItemsPerDate: QueryData["aliveItemsPerDate"];
	// 追加料金
	additionalFees: QueryData["aliveItemsPerReservation"]["additionalFees"];
};

export const ListOfAdditionalFeesCompositions = memo(
	({ adultNum, kidsNum, roomNum, aliveItemsPerDate, additionalFees }: Props) => {
		/**
		 * 宿泊日数
		 */
		const dateLength = useMemo(() => aliveItemsPerDate.length - 1, [aliveItemsPerDate]); // 最終日はチェックアウト日になるので除外してカウント
		/**
		 * 人数の合計
		 */
		const totalPeople = useMemo(() => adultNum + kidsNum, [adultNum, kidsNum]);

		/**
		 *
		 */
		const getBillingTermText = useCallback((term: BillingTypeTerm) => {
			return term === BillingTypeTerm.PerDate ? "1泊" : "1予約";
		}, []);
		/**
		 *
		 */
		const getBillingTermPricePrefixText = useCallback(
			(term: BillingTypeTerm) => {
				return term === BillingTypeTerm.PerDate ? dateLength + "泊" : "1予約";
			},
			[dateLength],
		);

		/**
		 *
		 */
		const getBillingTypeTargetText = useCallback((target: BillingTypeTarget) => {
			if (target === BillingTypeTarget.Group) return "1団体様";

			if (target === BillingTypeTarget.Person) return "1名様";

			if (target === BillingTypeTarget.Room) return "1部屋";

			/**
			 * PERSON_ONLY_KIDS は考慮しない
			 */
			return "";
		}, []);
		/**
		 *
		 */
		const getBillingTypeTargetPricePrefixText = useCallback(
			(target: BillingTypeTarget) => {
				if (target === BillingTypeTarget.Group) return "1団体様";

				if (target === BillingTypeTarget.Person) return totalPeople + "名様";

				if (target === BillingTypeTarget.Room) return roomNum + "部屋";

				/**
				 * PERSON_ONLY_KIDS は考慮しない
				 */
				return "";
			},
			[roomNum, totalPeople],
		);

		return (
			<>
				{additionalFees.map((item, index) => {
					return (
						<div key={index} className="space-y-4">
							<div>
								{/* 名前 */}
								<p>{item.name}</p>

								{/* 単価 */}
								<p className="text-xs text-caption-50">{`${getBillingTypeTargetText(item.billingTypeTarget)}×${getBillingTermText(item.billingTypeTerm)}あたり${item.unitPrice.toLocaleString()}円`}</p>

								{/* 予約内容 */}
								<p className="text-sm">{`${getBillingTypeTargetPricePrefixText(item.billingTypeTarget)}×${getBillingTermPricePrefixText(item.billingTypeTerm)}`}</p>
							</div>

							{/* 金額 */}
							<ApplyPriceText
								hostInsertedPrice={item.hostInsertedPrice ?? undefined}
								discountedPrice={item.totalDiscountedPrice ?? undefined}
								price={item.totalPrice}
							/>
						</div>
					);
				})}
			</>
		);
	},
);
